export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';

export const setCsrfToken = (csrfToken) => {
  return {
    type: SET_CSRF_TOKEN,
    payload: csrfToken
  };
};
